import { createAction } from '@reduxjs/toolkit';
import { ITopicsState } from '@store/topics/types';

export class EditTopicFailure {
  static get action() {
    return createAction('topics/Edit_TOPIC_FAILURE');
  }

  static get reducer() {
    return (draft: ITopicsState) => {
      draft.requests.editTopicPending = false;
    };
  }
}
